import { useAutoOptimization } from '../_hooks/useAutoOptimization';
import { AutoOptimizationScreen } from '../_types';
import { ApplyingScreen } from './screens/ApplyingScreen';
import { CompletedScreen } from './screens/CompletedScreen';
import { ExclusionsScreen } from './screens/ExclusionsScreen';
import { FeaturesScreen } from './screens/FeaturesScreen';
import { ProfileScreen } from './screens/ProfileScreen';
import { RecommendationsScreen } from './screens/RecommendationsScreen';

export const AutoOptimizationScreenRouter = () => {
  const { currentScreen } = useAutoOptimization();

  switch (currentScreen) {
    case AutoOptimizationScreen.Priority:
      return <ProfileScreen />;
    case AutoOptimizationScreen.Features:
      return <FeaturesScreen />;
    case AutoOptimizationScreen.Exclusions:
      return <ExclusionsScreen />;
    case AutoOptimizationScreen.Recommendations:
      return <RecommendationsScreen />;
    case AutoOptimizationScreen.Applying:
      return <ApplyingScreen />;
    case AutoOptimizationScreen.Completed:
      return <CompletedScreen />;
    default:
      return null;
  }
};
